import { useStore } from 'effector-react'
import { useMemo } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { RentalServiceAccordion } from '~/entities/RentalService'
import { DailyDebitSchedule } from '~/entities/RentalService'
import { viewerModel } from '~/entities/viewer'
import {
  daysEnumLabels,
  daysEnumOptions,
  rentalContractQuantityOfHoursEnumOptions,
  rentalContractWorkScheduleEnumOptions,
} from '~/shared/config/constants'
import { RentalContractWorkScheduleEnum } from '~/shared/config/enums'
import { getDay } from '~/shared/lib/date'
import { featureFlagModel } from '~/shared/lib/featureFlag'
import { FormProvider, Select } from '~/shared/ui/form'
import { FormValues } from './model'
import { Wrapper } from './styled'

export type FormProps = {
  instanceForm: UseFormReturn<FormValues>
}

export function Form({ instanceForm }: FormProps) {
  const authenticated = viewerModel.useAuthenticated()
  const featureFlags = useStore(featureFlagModel.$featureFlags)

  const { watch, setValue } = instanceForm

  const workSchedule = watch('workSchedule')

  const isSixThroughOne =
    workSchedule?.id === RentalContractWorkScheduleEnum.SIX_THROUGH_ONE

  const mappedDaysEnumOptions = useMemo(() => {
    const today = getDay('current')

    return daysEnumOptions.map((option) =>
      option.id === today ? { ...option, disabled: true } : option,
    )
  }, [])

  watch((data, { type, name }) => {
    if (type !== 'change') return

    if (name === 'workSchedule') {
      const id = data.workSchedule?.id

      if (id === RentalContractWorkScheduleEnum.FULL_WEEK) {
        setValue('dayOff', null)
      }

      if (id === RentalContractWorkScheduleEnum.SIX_THROUGH_ONE) {
        const yesterday = getDay('yesterday')
        setValue('dayOff', { id: yesterday, label: daysEnumLabels[yesterday] })
      }
    }
  })

  return (
    <FormProvider form={instanceForm}>
      <Wrapper>
        <Select
          options={rentalContractWorkScheduleEnumOptions}
          name='workSchedule'
          label='Выберите график'
          modalTitle='График работы'
          drawerFullScreen={false}
        />

        {isSixThroughOne && (
          <Select
            options={mappedDaysEnumOptions}
            name='dayOff'
            label='Выходной день'
            modalTitle='Выходной день'
            drawerFullScreen={false}
          />
        )}
        {featureFlags.quantity_rental_payments && (
          <>
            <Select
              options={rentalContractQuantityOfHoursEnumOptions}
              name='quantityRentalPayments'
              label='Выберите график списаний в сутки'
              modalTitle='График списаний в сутки'
              drawerFullScreen={false}
            />
            <div style={{ paddingBottom: '12px' }}>
              <DailyDebitSchedule />
            </div>
          </>
        )}

        {authenticated && <RentalServiceAccordion />}
      </Wrapper>
    </FormProvider>
  )
}
